'use client';

import { motion } from 'framer-motion';

export function ScrollAnimationSection() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-b from-slate-50 to-white px-4 py-20 dark:from-slate-900 dark:to-slate-950 md:py-32">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h1 className="mb-2 text-4xl font-semibold text-slate-900 dark:text-white md:text-5xl">
            Unleash the power of{' '}
          </h1>
          <motion.span
            initial={{ opacity: 0, filter: 'blur(10px)' }}
            whileInView={{ opacity: 1, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="block bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-4xl font-bold text-transparent dark:from-blue-400 dark:to-blue-500 md:text-6xl"
          >
            Scroll Animations
          </motion.span>
          <p className="mt-6 text-lg text-slate-600 dark:text-slate-400">
            Experience smooth, delightful animations that respond to your scroll
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative mx-auto mt-16 aspect-video w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-100 to-slate-50 dark:border-slate-700 dark:from-slate-800 dark:to-slate-900"
        >
          <div className="flex h-full items-center justify-center">
            <div className="text-center">
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
                className="mb-4 text-6xl"
              >
                ⬇️
              </motion.div>
              <p className="text-slate-600 dark:text-slate-400">Scroll Animation Preview</p>
              <p className="mt-2 text-sm text-slate-500 dark:text-slate-500">
                (Container scroll animation component)
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
